<template>
  <cw-page
    icon="warning"
    class="application__rejected"
  >
    <v-row>
      <v-col>
        <!-- Existing customers -->
        <template v-if="getIsCurrentCustomer">
          <p class="application__rejected__text">
            <translate>
              At this time, we are unable to grant you a new loan.
            </translate>
          </p>
        </template>

        <!-- New customers -->
        <template v-else>
          <p class="application__rejected__text">
            <translate>
              The loan application has been interrupted because unfortunately we are unable to grant
              the loan at this time.
            </translate>
          </p>
        </template>
      </v-col>
    </v-row>
  </cw-page>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'CwRejection',

  computed: {
    ...mapGetters({
      getIsCurrentCustomer: 'application/getIsCurrentCustomer',
    }),
  },

  async created() {
    await this.isCurrentCustomer();
  },

  methods: {
    ...mapActions({
      isCurrentCustomer: 'application/isCurrentCustomer',
    }),
  },
};
</script>
